module.exports = __webpack_public_path__ + "media/images/icn-pdf-d3ab4fa7bc37823022d286eef311d440.svg";